import React from 'react';
import { Building, Users, Target, Map } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen bg-white pt-16">
      {/* Header Banner */}
      <section className="bg-blue-700 py-24 bglog">
        <div className="container mx-auto px-6">
          <h1 className="text-4xl font-bold text-white text-center">About Us</h1>
        </div>
      </section>

      {/* Mission and Vision */}
      <section className="py-16 container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row gap-12">
            <div className="md:w-1/2">
              <div className="flex items-center mb-4">
                <div className="bg-blue-100 p-3 rounded-full mr-3">
                  <Target className="text-blue-700" size={24} />
                </div>
                <h2 className="text-2xl font-bold">Our Mission</h2>
              </div>
              <p className="text-gray-600 mb-6">
                Our mission is to modernize and streamline the building approval process through 
                digitalization. We aim to reduce paperwork, increase transparency, and accelerate 
                the time it takes for building designs to be approved, all while maintaining the 
                highest standards of safety and compliance.
              </p>
            </div>
            <div className="md:w-1/2">
              <div className="flex items-center mb-4">
                <div className="bg-blue-100 p-3 rounded-full mr-3">
                  <Map className="text-blue-700" size={24} />
                </div>
                <h2 className="text-2xl font-bold">Our Vision</h2>
              </div>
              <p className="text-gray-600 mb-6">
                We envision a future where the building approval process is entirely digital, 
                efficient, and accessible to all stakeholders. Our platform will serve as 
                the industry standard for digital approvals, fostering innovation in architecture 
                and construction while ensuring compliance with local and national regulations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Team */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12">Our Team</h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-white p-6 rounded-lg shadow-sm text-center">
              <div className="w-24 h-24 bg-gray-200 rounded-full mx-auto mb-4 flex items-center justify-center">
                <Users className="text-gray-500" size={36} />
              </div>
              <h3 className="text-xl font-semibold mb-1">John Smith</h3>
              <p className="text-blue-700 mb-3">Chief Executive Officer</p>
              <p className="text-gray-600 text-sm">
                With over 20 years of experience in urban planning and building regulations,
                John leads our organization with vision and expertise.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm text-center">
              <div className="w-24 h-24 bg-gray-200 rounded-full mx-auto mb-4 flex items-center justify-center">
                <Users className="text-gray-500" size={36} />
              </div>
              <h3 className="text-xl font-semibold mb-1">Sarah Johnson</h3>
              <p className="text-blue-700 mb-3">Chief Technology Officer</p>
              <p className="text-gray-600 text-sm">
                Sarah brings her extensive knowledge in software development and 3D modeling
                to create our innovative digital approval platform.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm text-center">
              <div className="w-24 h-24 bg-gray-200 rounded-full mx-auto mb-4 flex items-center justify-center">
                <Users className="text-gray-500" size={36} />
              </div>
              <h3 className="text-xl font-semibold mb-1">Michael Brown</h3>
              <p className="text-blue-700 mb-3">Building Authority Liaison</p>
              <p className="text-gray-600 text-sm">
                Michael works closely with local and national building authorities to ensure
                our platform meets all regulatory requirements.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Organization Info */}
      <section className="py-16 container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center mb-6">
            <div className="bg-blue-100 p-3 rounded-full mr-3">
              <Building className="text-blue-700" size={24} />
            </div>
            <h2 className="text-2xl font-bold">Our Organization</h2>
          </div>
          <p className="text-gray-600 mb-8">
            The Digital Approval of Building Designs platform is managed by the National Building
            Authority, a regulatory body responsible for ensuring all building designs meet
            safety, accessibility, and environmental standards. Our team consists of experienced
            architects, engineers, urban planners, and software developers dedicated to simplifying
            the building approval process while maintaining the highest standards of quality.
          </p>
          
          <div className="bg-gray-50 p-6 rounded-lg">
            <h3 className="text-xl font-semibold mb-4">Contact Information</h3>
            <div className="space-y-3">
              <p className="flex items-start">
                <span className="font-medium w-24">Address:</span>
                <span className="text-gray-600">123 Building Authority Plaza, Suite 500, Metropolis, MP 12345</span>
              </p>
              <p className="flex items-start">
                <span className="font-medium w-24">Phone:</span>
                <span className="text-gray-600">(555) 123-4567</span>
              </p>
              <p className="flex items-start">
                <span className="font-medium w-24">Email:</span>
                <span className="text-gray-600">contact@buildingapprovals.gov</span>
              </p>
              <p className="flex items-start">
                <span className="font-medium w-24">Hours:</span>
                <span className="text-gray-600">Monday to Friday: 8:00 AM - 5:00 PM</span>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;